export default __webpack_public_path__ + "assets/images/turtle-yellow-16d38063b07a87031ed504de04778615.svg";